module.exports = __webpack_public_path__ + "50af1f5bb14cebeb138e7e046ae4368b.ttf";